module.exports = __webpack_public_path__ + "assets/measure_vehicle_statuses.782cc84d.svg";